import { IonIcon } from '@ionic/react';
import { closeOutline } from 'ionicons/icons';
import { MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';

interface CloseButtonProps {
  to: any;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  icon?: string;
}

export const CloseButton: React.FC<CloseButtonProps> = ({
  to,
  onClick = (e) => false,
  icon = closeOutline,
}) => (
  <div className="flex justify-center items-center w-0 h-0 p-3 rounded-full bg-primary">
    <Link to={to} style={{ lineHeight: 0 }} onClick={onClick}>
      <IonIcon className="text-white text-l leading-none" icon={icon} />
    </Link>
  </div>
);
